import React from "react";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";

const StructuralVariantsCard = ({ card }) => {
  const cardTitle = (
    <div className="tw-flex tw-items-baseline">
      <span className="tw-mr-1">{card.title}</span>
      <i className="fa fa-tasks tw-text-blue-500" />
    </div>
  );
  return <CardWrapper {...card} title={cardTitle} humanTitle={card.title} />;
};

StructuralVariantsCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
};

export default StructuralVariantsCard;
